export const getChatBotMessages = (data) => {
  const messages = [];
  const method = data?.method;
  const payload = data?.payload;
  const botMessage = data?.botMessage;
  const refundIds=data?.payload?.payload?.invoiceIds;
  const paymentCreatedAt=data?.createdAt || new Date().toISOString();

  if (method === 'account_topup') {
    messages.push({
      payment: {
        message: 'Here is your payment link:',
        amount: payload?.amount,
        buttonText: 'Pay Now',
        paymentDetails:{
          paymentCreatedAt:paymentCreatedAt
        },
      },
      sender: 'bot',
    });
  }

  else if (method === 'general_response') {
    messages.push({
      text: botMessage,
      sender: 'bot',
    });
  }

  else if (method === 'faq_response') {
    messages.push({
      text: botMessage,
      sender: 'bot',
      method: 'faq_response',
    });
  }

  else if (method === 'refund') {
    const refundType = payload?.payload?.type;
    const refundAmount = payload?.payload?.amountRefunded;

    const refundMessages = {
      other: {
        refund: {
          message: data?.message,
          showSupportBtn: false,
          refundAmount: 0,
          refundIds:refundIds
        },
      },
      refund_initiated: {
        refund: {
          message: `Your refund request of ₹${refundAmount} has been initiated and will be reflected in your bank account within 2 working days.`,
          refundAmount,
          showSupportBtn: false,
          refundIds:refundIds
        },
      },
      refund_initiated_manual_required: {
        refund: {
          message: `Your refund request of ₹${refundAmount} has been initiated and will be reflected in your bank account within 2 working days.`,
          refundAmount,
          showSupportBtn: true,
          buttonText:'Talk To Support',
          refundIds:refundIds
        },
      },
      manual_refund_required: {
        refund: {
          message: 'Your refund request has been initiated and will be processed manually.',
          showSupportBtn: true,
          refundAmount: 0,
          buttonText:'Talk To Support',
          refundIds:refundIds
        },
      },
      active_session_blocked: {
        refund: {
          message: data?.message || 'A charging session is currently active. Refund cannot be initiated until the session is completed. Our support team has been notified.',
          showSupportBtn: true,
          refundAmount: 0,
          buttonText: 'Talk To Support',
          refundIds: refundIds,
        },
      },
    };

    if (refundMessages[refundType]) {
      messages.push({
        ...refundMessages[refundType],
        sender: 'bot',
      });
    }
  }

  else if (method === 'previous_search') {
    const caseType = payload?.case;

    messages.push({
      text: botMessage,
      sender: 'bot',
    });

    if (caseType === 'no_session_found') {
      messages.push({
        searchStation: { searchStation: true },
        sender: 'bot',
      });
    }

    if (caseType === 'multiple_chargers_available') {
      messages.push({
        chargingPoints: payload?.data?.map(point => ({
          name: point.charging_point_name,
          power: point.model?.output_max,
          price: point.tariff?.value_per_kwh,
          lastSession: point.charging_sessions?.length > 0
            ? new Date(
                new Date(point.charging_sessions[0].createdAt).getTime() +
                19800000 - // IST offset
                60000 // 1 minute less
              ).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
            : null,
        })),
      });
    } 
  }
  else if (method === 'list_chargers') {
    messages.push({
      chargingPoints: payload?.[0]?.available_points?.map((point) => ({
          name: point.charging_point_name,
          power: point.model?.output_max,
          price: point.tariff?.value_per_kwh,
          lastSession: point.charging_sessions?.length > 0
            ? new Date(
                new Date(point.charging_sessions[0].createdAt).getTime() +
                19800000 - // IST offset
                60000 // 1 minute less
              ).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
            : null,
        })),
      });
    } 
  

  else if (method === 'list_stations') {
    messages.push({
      text: botMessage,
      sender: 'bot',
    });

    messages.push({
      stations: payload?.map(station => ({
        name: station.station_name,
        lastSession: '16 min ago', // Hardcoded, might need dynamic time in future
      })),
    });
  }

  else if (method === 'no_match_station') {
    messages.push({
      text: botMessage,
      sender: 'bot',
    });

    messages.push({
      searchStation: { searchStation: true },
      sender: 'bot',
    });
  }

  else if (method === 'balance') {
    messages.push({
      text: `Your current wallet balance is ₹${payload?.walletBalance}`,
      sender: 'bot',
    });
  }

  else if (method === 'faq_support_required_response') {
    messages.push({
      refund: {
        message: botMessage,
        showSupportBtn: true,
        buttonText:'Talk To Support',
        refundAmount: 0,
      },
      sender: 'bot',
    });
  }  else if (method === 'show_other_bots') {
    messages.push({
      showAllBots: {
        showAllBots: true,
      },
      sender: 'bot',
    });
  } else if (method === 'customer_profile'){
    messages.push({
      chargingSessions: {
        totalSessions: payload?.totalChargingTransactions,
        totalAmount: payload?.totalAmountSpend,
        totalUnits: payload?.totalEnergyDelivered,
        co2Saved:payload?.totalCarbonSaved,
      },
      sender: 'bot',
    });
  }  else if (data?.message === "Error in workflow") {
    messages.push({
      text: "Oops!something went wrong, There was an unexpected error.Please bear with me for a moment.Please try again later, after sometime.",
      sender: 'bot',
    });

  }

  return messages;
};
